import { render, staticRenderFns } from "./CaseMedicationDetails.vue?vue&type=template&id=ca3ae4a8&scoped=true&"
import script from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationDetails.vue?vue&type=style&index=0&id=ca3ae4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ae4a8",
  null
  
)

export default component.exports